// src/components/tab/tab-nav-item.js

import React from "react";
const TabNavItem = ({ id, title, activeTab, setActiveTab }) => {
 
 const handleClick = () => {
  setActiveTab(id);
 };

 
return (
   <li
     onClick={handleClick}
     className={`list-none cursor-pointer px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
       activeTab === id
         ? "bg-blue-600 text-white shadow-sm"
         : "text-neutral-600 hover:bg-neutral-200 hover:text-neutral-800"
     }`}
   >
     {title}
   </li>
 );
};
export default TabNavItem;